import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/Check";
import {
  Box,
  Chip,
  CircularProgress,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Label from "../../../components/Label";
import SnackbarAlert from "../../../components/SnackBar";
import TextInput from "../../../components/TextInputs";
import { getBranchCategory } from "../../../services/Category";

const AboutVenue = ({ inputValues, setInputValues }) => {
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  useEffect(() => {
    handleFetchCategory();
  }, []);

  const handleFetchCategory = async () => {
    try {
      setIsLoading(true);
      const response = await getBranchCategory();
      setIsLoading(false);
      if (response?.status === 200 || response?.status === 201) {
        setCategories(response.data.data);
      } else {
        handleSnackbarVal(true, "error", response?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching categories:", error);
      handleSnackbarVal(true, "error", "Failed to fetch categories");
    }
  };

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({ open, type, message });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleCategoryChange = (event) => {
    setInputValues((prevValues) => ({
      ...prevValues,
      categories: event.target.value,
    }));
  };

  const handleDeleteCategory = (categoryToDelete) => {
    setInputValues((prevValues) => ({
      ...prevValues,
      categories: prevValues.categories.filter(
        (cat) => cat !== categoryToDelete
      ),
    }));
  };

  return (
    <Box>
      {isLoading && <CircularProgress />}
      <SnackbarAlert
        handleCloseSnackbar={handleCloseSnackbar}
        snackbarProps={snackbarProps}
      />
      <Grid container justifyContent={"center"}>
        <Grid item xs={12} sm={8} md={4.5}>
          <Typography variant="h3" sx={{ fontWeight: "700", fontSize: "21px" }}>
            Tell us a bit about this venue
          </Typography>
          <Typography
            variant="h3"
            sx={{ fontWeight: "700", fontSize: "21px", marginBottom: "15px" }}
          >
            Add the display name you'd like to be known by, along with a short
            description of your business and the services you offer
          </Typography>

          <Label labelText="Display Name" htmlFor={"displayName"} required />
          <TextInput
            required={true}
            placeholder={"Display Name"}
            type={"text"}
            name="displayName"
            value={inputValues.displayName}
            onChange={handleChange}
            style={{ marginBottom: "20px" }}
          />

          <Label
            labelText="Select Categories"
            htmlFor={"categories"}
            required
          />
          <Select
            multiple
            value={inputValues.categories || []}
            onChange={handleCategoryChange}
            displayEmpty
            renderValue={(selected) => (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {selected.map((id) => {
                  const selectedCategory = categories.find(
                    (cat) => cat._id === id
                  );
                  return selectedCategory ? (
                    <Chip
                      key={id}
                      label={selectedCategory.name}
                      onDelete={() => handleDeleteCategory(id)}
                      deleteIcon={<CancelIcon />}
                    />
                  ) : null;
                })}
              </Box>
            )}
            sx={{ width: "100%", marginBottom: "20px" }}
          >
            {categories.map((category) => (
              <MenuItem key={category._id} value={category._id}>
                {inputValues.categories?.includes(category._id) && (
                  <CheckIcon sx={{ marginRight: "8px" }} />
                )}
                {category.name}
              </MenuItem>
            ))}
          </Select>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Label labelText="About" htmlFor={"about"} required />
            <Typography
              variant="h3"
              sx={{ fontWeight: "400", fontSize: "14px" }}
            >
              215/600
            </Typography>
          </Box>
          <TextInput
            required={true}
            placeholder={"About"}
            type={"text"}
            name="aboutUs"
            multiline
            rows={5}
            value={inputValues.aboutUs}
            onChange={handleChange}
          />
          <Typography
            variant="h3"
            sx={{ fontWeight: "400", fontSize: "14px", marginTop: "10px" }}
          >
            A minimum of 200 characters is required
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AboutVenue;
